import { PropertyAssets } from "@superwall-me/schema";
export const parsePaywallAsset = (paywallAsset)=>{
    const foo = {
        ...paywallAsset,
        attributes: PropertyAssets.parse(paywallAsset.attributes)
    };
    return foo;
};
